export enum Permission {
  AddCommentOnMoveRequest = "AddCommentOnMoveRequest",
  AddEditDoorCollection = "AddEditDoorCollection",
  AddEditLocation = "AddEditLocation",
  AddEditPartner = "AddEditPartner",
  AddEditRFID = "AddEditRFID",
  AddEditSite = "AddEditSite",
  AddEditTrailerType = "AddEditTrailerType",
  BackToPendingMoveRequest = "BackToPendingMoveRequest",
  CompleteMoveRequest = "CompleteMoveRequest",
  CreateDriverMoveRequest = "CreateDriverMoveRequest",
  CreateMoveRequest = "CreateMoveRequest",
  CreateMoveRequestFromDockActivity = "CreateMoveRequestFromDockActivity",
  CreateNewTrailer = "CreateNewTrailer",
  CreateSpotTruckInspection = "CreateSpotTruckInspection",
  DeleteDoorCollection = "DeleteDoorCollection",
  DeleteEditLocation = "DeleteEditLocation",
  DeleteMoveRequest = "DeleteMoveRequest",
  DeleteRFID = "DeleteRFID",
  DeleteSCAC = "DeleteSCAC",
  EditAppointmentStatus = "EditAppointmentStatus",
  EditDefaultSCAC = "EditDefaultSCAC",
  EditDisplayFieldsSettings = "EditDisplayFieldsSettings",
  EditDriverMoveRequest = "EditDriverMoveRequest",
  EditGeneralSiteSettings = "EditGeneralSiteSettings",
  EditLocationSetOutOfService = "EditLocationSetOutOfService",
  EditMoveRequest = "EditMoveRequest",
  EditTrailerDetails = "EditTrailerDetails",
  EditTrailerLocation = "EditTrailerLocation",
  EditTrailerStatus = "EditTrailerStatus",
  LiveSpotTrailerToDoorAsEmpty = "LiveSpotTrailerToDoorAsEmpty",
  ManageGuardPromptSettings = "ManageGuardPromptSettings",
  ManageSpotTruckInspectionSettings = "ManageSpotTruckInspectionSettings",
  OnLoginCollapseMenu = "OnLoginCollapseMenu",
  PauseMoveRequest = "PauseMoveRequest",
  PullTrailerToYardAsEmpty = "PullTrailerToYardAsEmpty",
  StartMoveRequest = "StartMoveRequest",
  UnPauseMoveRequest = "UnPauseMoveRequest",
  ViewDashboard = "ViewDashboard",
  ViewDisplayFieldsSettings = "ViewDisplayFieldsSettings",
  ViewDockActivity = "ViewDockActivity",
  ViewDoorCollections = "ViewDoorCollections",
  ViewDropTrailerList = "ViewDropTrailerList",
  ViewGeneralSiteSettings = "ViewGeneralSiteSettings",
  ViewGlobalSettings = "ViewGlobalSettings",
  ViewLocationList = "ViewLocationList",
  ViewMoveRequest = "ViewMoveRequest",
  ViewMoveRequestList = "ViewMoveRequestList",
  ViewMoveRequestListActions = "ViewMoveRequestListActions",
  ViewNewSignUpsList = "ViewNewSignUpsList",
  ViewOffComplexList = "ViewOffComplexList",
  ViewPartnerList = " ViewPartnerList",
  ViewPurchaseOrderInformation = "ViewPurchaseOrderInformation",
  ViewPurchaseOrderList = "ViewPurchaseOrderList",
  ViewRFIDList = "ViewRFIDList",
  ViewReports = "ViewReports",
  ViewScacList = "ViewScacList",
  ViewSiteList = "ViewSiteList",
  ViewSiteSettings = "ViewSiteSettings",
  ViewTrailerDetails = "ViewTrailerDetails",
  ViewTrailerTypes = "ViewTrailerTypes",
}

const allPermissions = new Set<Permission>(Object.values(Permission));

export function isPermission(value: unknown): value is Permission {
  // If the list of all permissions has the value, then it must be a permission,
  // otherwise it's not. Thus, this type assertion should be fine.
  return allPermissions.has(value as Permission);
}

export function isPermissionArray(
  values: unknown,
): values is readonly Permission[] {
  return Array.isArray(values) && values.every(isPermission);
}
